import React from 'react';
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const DoubleImage = (props) => {
    const doubleImage = props.item;
    if(!doubleImage) return '';

    const active = doubleImage.active;

    const imageResponsiveA = {
        768: (doubleImage.image_a.image_a_mobile) || doubleImage.image_a.image_mobile,
        1440: (doubleImage.image_a.image_a_desktop) || doubleImage.image_a.image_desktop
    };

    const imageResponsiveB = {
        768: (doubleImage.image_b.image_b_mobile) || doubleImage.image_b.image_mobile,
        1440: (doubleImage.image_b.image_b_desktop) || doubleImage.image_b.image_desktop
    };

    let img1 = {}
    let img2 = {}
    const creative = 'Banner Secundario Grid'

    const gtmData = (item) => {

        if(item.image_a.image_a_desktop){
            img1 = {
                id: item.image_a.image_a_desktop.split('/').pop(),
                name: item.image_a.image_a_desktop.split('/').pop(),
                creative: creative,
                position: 'slot-' + item.position_a,
                type: 'secondaryGridBanner',
            }
        }
        if(item.image_a.image_desktop){
            img1 = {
                id: item.image_a.image_desktop.split('/').pop(),
                name: item.image_a.image_desktop.split('/').pop(),
                creative: creative,
                position: 'slot-' + item.position_a,
                type: 'secondaryGridBanner',
            }
        }

        if(item.image_b.image_b_desktop){
            img2 = {
                id: item.image_b.image_b_desktop.split('/').pop(),
                name: item.image_b.image_b_desktop.split('/').pop(),
                creative: creative,
                position: 'slot-' + item.position_b,
                type: 'secondaryGridBanner',
            }
        }
        if(item.image_b.image_desktop){
            img2 = {
                id: item.image_b.image_desktop.split('/').pop(),
                name: item.image_b.image_desktop.split('/').pop(),
                creative: creative,
                position: 'slot-' + item.position_b,
                type: 'secondaryGridBanner',
            }
        }
    }

    const promotionClickA = () => {
        let imageA = {};
        if(doubleImage.image_a.image_a_desktop){
            imageA = {
                id: doubleImage.image_a.image_a_desktop.split('/').pop(),
                name: doubleImage.image_a.image_a_desktop.split('/').pop()
            }
        }
        if(doubleImage.image_a.image_desktop){
            imageA = {
                id: doubleImage.image_a.image_desktop.split('/').pop(),
                name: doubleImage.image_a.image_desktop.split('/').pop()
            }
        }

        TagManagerService.promotionsClick(imageA, 'slot' + doubleImage.position_a, creative);
    }

    const promotionClickB = () => {
        let imageB = {};
        if(doubleImage.image_b.image_b_desktop){
            imageB = {
                id: doubleImage.image_b.image_b_desktop.split('/').pop(),
                name: doubleImage.image_b.image_b_desktop.split('/').pop()
            }
        }
        if(doubleImage.image_b.image_desktop){
            imageB = {
                id: doubleImage.image_b.image_desktop.split('/').pop(),
                name: doubleImage.image_b.image_desktop.split('/').pop()
            }
        }
        TagManagerService.promotionsClick(imageB, 'slot' + doubleImage.position_b, creative);
    }

    gtmData(doubleImage)

    return (
        <div className="double-image">
            {(active === true) && <Link to={doubleImage.image_a.url} onClick={() => promotionClickA()} className="double-image-content">
                <ImageLoad srcSet={imageResponsiveA} src={imageResponsiveA[1440]} alt={doubleImage.title || doubleImage.image_a.image_desktop} gtmData={img1} />
            </Link>}

            {(active === true) && <Link to={doubleImage.image_b.url} onClick={() => promotionClickB()} className="double-image-content">
                <ImageLoad srcSet={imageResponsiveB} src={imageResponsiveB[1440]} alt={doubleImage.title || doubleImage.image_b.image_desktop} gtmData={img2}/>
            </Link>}
        </div>
    )
}

DoubleImage.propTypes = {
    item: PropTypes.object,
    active: PropTypes.bool
};

export default DoubleImage;
